/**
 * Canonical order-domain enums. Values match the Postgres enum types on
 * `order_core` — changing values requires a migration + backfill. Shipment-
 * specific statuses (ASSIGNED, PICKED_UP, OUT_FOR_DELIVERY, FAILED_DELIVERY)
 * live on `ShipmentStatus`, not here.
 */

export enum OrderStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  PROCESSING = 'processing',
  IN_TRANSIT = 'in_transit',
  DELIVERED = 'delivered',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ON_HOLD = 'on_hold',
  RETURNED = 'returned',
}

export enum OrderType {
  STANDARD = 'standard',
  EXPRESS = 'express',
  SAME_DAY = 'same_day',
  NEXT_DAY = 'next_day',
  SCHEDULED = 'scheduled',
  RECURRING = 'recurring',
  BULK = 'bulk',
  SAMPLE = 'sample',
}

export enum OrderPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
  CRITICAL = 'critical',
}

export enum OrderPaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  PARTIAL = 'partial',
  OVERDUE = 'overdue',
  REFUNDED = 'refunded',
  DISPUTED = 'disputed',
}

export enum OrderPaymentMethod {
  CASH = 'cash',
  CREDIT_CARD = 'credit_card',
  BANK_TRANSFER = 'bank_transfer',
  CHECK = 'check',
  ON_ACCOUNT = 'on_account',
  COD = 'cod',
  OTHER = 'other',
}

/**
 * Cargo classification — not a Postgres enum (stored as `cargo_type varchar`);
 * keep the TS enum authoritative so forms and display layers share one list.
 */
export enum CargoType {
  GENERAL = 'general',
  FRAGILE = 'fragile',
  HAZARDOUS = 'hazardous',
  PERISHABLE = 'perishable',
  HIGH_VALUE = 'high_value',
  OVERSIZED = 'oversized',
  LIQUID = 'liquid',
  FROZEN = 'frozen',
}

/**
 * Service-level tier. Also stored as `service_level varchar`; TS enum is
 * authoritative.
 */
export enum ServiceLevel {
  STANDARD = 'standard',
  EXPRESS = 'express',
  PREMIUM = 'premium',
  WHITE_GLOVE = 'white_glove',
}

// Display labels: i18n (`orders.statuses.*`). Badge colors:
// `packages/common/src/constants/status-colors.ts`.
